import { createContext, useContext, useEffect, useState, useMemo } from "react";

const KEY = "tm_lang";

const dict = {
  es: {
    nav: { services: "Servicios", quiz: "Quiz de Belleza", about: "Sobre Tania", cases: "Casos", patients: "Pacientes", location: "Ubicación", contact: "Contacto", admin: "Admin", book: "Agendar cita" },
    hero: {
      badge: "Pachuca, Hidalgo",
      titlePre: "Sonríe con",
      titleHighlight: "confianza",
      titlePost: ", vive con seguridad.",
      subtitlePre: "",
      subtitleStrong1: "Ortodoncia",
      subtitleAnd: "y",
      subtitleStrong2: "Medicina Estética",
      subtitleBody: "con la Dra. Tania Mendoza, en Pachuca. Atención cercana, tratamientos para todas las edades y",
      subtitleStrong3: "planes a meses sin intereses",
      subtitleEnd: ". Tu primera valoración es gratis.",
      cta: "Valoración sin costo",
      linkServices: "Conoce los servicios",
      stat1: { n: (p) => `+${p}`, label: "Pacientes" },
      stat2: { n: (y) => `${y} años`, label: "Experiencia" },
      stat3: { n: "MSI", label: "Meses sin intereses" },
      stat4: { n: "Gratis", label: "1ª valoración" },
      certBadge: "Certificada",
      university: "Universidad Autónoma del Estado de Hidalgo",
    },
    services: {
      eyebrow: "— Servicios",
      title1: "Dos especialidades.",
      title2: "Un mismo objetivo:",
      titleEm: "que te sientas bien contigo.",
      sub: "Tratamientos para niños, adolescentes y adultos. Diseñamos un plan a tu medida, con opciones para cada presupuesto.",
      tabs: { estetica: "Medicina Estética", ortodoncia: "Ortodoncia" },
      list: [
        // Medicina Estética
        { id: "toxina", title: "Toxina Botulínica", area: "estetica", desc: "Suaviza líneas dinámicas en frente, entrecejo y patas de gallo. Acabado natural, sin rigidez." },
        { id: "ellanse", title: "Ellansé", area: "estetica", desc: "Bioestimulador de colágeno premium para rejuvenecimiento profundo. Resultados que duran hasta 4 años." },
        { id: "sculptra", title: "Sculptra", area: "estetica", desc: "Bioestimulador de ácido poliláctico. Estimula tu propio colágeno gradualmente para resultados muy naturales." },
        { id: "rino", title: "Rinomodelación", area: "estetica", desc: "Corrección del perfil nasal con ácido hialurónico. Sin bisturí, sin tiempo de recuperación." },
        { id: "labios", title: "Relleno de Labios", area: "estetica", desc: "Volumen y definición con ácido hialurónico premium. Resultado armónico, hidratado y natural." },
        { id: "ojeras", title: "Adiós Ojeras", area: "estetica", desc: "Rejuvenecimiento del contorno de ojos con ácido hialurónico y bioestimuladores. Mirada descansada." },
        { id: "surcos", title: "Surcos Nasogenianos", area: "estetica", desc: "Relleno de las líneas de la sonrisa con ácido hialurónico. Apariencia descansada y juvenil." },
        { id: "marcaje", title: "Marcaje Mandibular & Mentón", area: "estetica", desc: "Definición de óvalo facial con ácido hialurónico. Mandíbula marcada y mentón armónico." },
        { id: "pomulos", title: "Pómulos & Full Face", area: "estetica", desc: "Restauración del soporte facial con técnica integral. Lifting natural sin cirugía." },
        { id: "maseteros", title: "Bótox Maseteros", area: "estetica", desc: "Relaja la mordida y suaviza el ángulo mandibular. Ideal para bruxismo y rostro más estilizado." },
        { id: "pdrn", title: "PDRN de Salmón & Exosomas", area: "estetica", desc: "Regeneración celular de última generación. Mejora textura, firmeza y luminosidad." },
        { id: "nctf", title: "NCTF Mesoterapia", area: "estetica", desc: "Cóctel vitamínico con 59 ingredientes para revitalizar la piel desde adentro. Glow inmediato." },
        { id: "dermapen", title: "Dermapen con Péptidos", area: "estetica", desc: "Microagujas + péptidos para estimular colágeno y mejorar cicatrices, poros y textura." },
        { id: "hydrofacial", title: "Hydrofacial", area: "estetica", desc: "Limpieza profunda + hidratación + infusión de activos en una sola sesión. Piel limpia y radiante." },
        { id: "limpieza_af", title: "Limpieza Facial Alta Frecuencia", area: "estetica", desc: "Limpieza profunda con corriente de alta frecuencia para combatir acné y purificar la piel." },
        { id: "peeling", title: "Peeling Químico", area: "estetica", desc: "Renueva la piel y mejora manchas, textura y cicatrices con ácidos médicos personalizados." },
        { id: "hollywood", title: "Hollywood Peel", area: "estetica", desc: "Peeling con láser Carbon. Unifica tono, reduce poros y deja la piel luminosa de inmediato." },
        { id: "hifu", title: "Lifting Facial HIFU", area: "estetica", desc: "Ultrasonido focalizado para tensar la piel sin cirugía. Resultados progresivos durante 3-6 meses." },
        { id: "enzimas", title: "Enzimas Lipolíticas (PB Serum)", area: "estetica", desc: "Reducción de papada y zonas localizadas de grasa. Resultados visibles en pocas sesiones." },
        { id: "aparatologia", title: "Aparatología Corporal", area: "estetica", desc: "Radiofrecuencia, cavitación y vacumterapia para moldear, reafirmar y reducir medidas." },
        { id: "mounjaro", title: "Control de Peso — Mounjaro", area: "estetica", desc: "Manejo médico del peso con seguimiento personalizado. Acompañamiento integral y seguro." },
        // Ortodoncia
        { id: "brackets", title: "Brackets", area: "ortodoncia", desc: "Metálicos, cerámicos o de zafiro. Para niños, adolescentes y adultos, con planes a meses sin intereses." },
        { id: "invisalign", title: "Alineadores Invisibles", area: "ortodoncia", desc: "Invisalign y alternativas accesibles. Cómodos, transparentes y casi imperceptibles." },
        { id: "ortopedia", title: "Ortopedia Funcional Infantil", area: "ortodoncia", desc: "Aprovecha el crecimiento del niño para guiar el desarrollo de los maxilares, corregir mordidas y prevenir tratamientos invasivos en adolescencia o adultez." },
      ],
    },
    credentials: {
      eyebrow: "— Formación",
      title1: "Formación continua",
      title2: "en las mejores escuelas.",
      sub: "La Dra. Tania se actualiza constantemente para ofrecer técnicas seguras y de vanguardia.",
      list: [
        { school: "Universidad Autónoma del Estado de Hidalgo", title: "Odontología", year: "" },
        { school: "AOMEI — Asociación Odontológica Mexicana", title: "Especialidad en Ortodoncia", year: "" },
      ],
    },
    quizCta: {
      tag: "Quiz · 2 minutos",
      title1: "¿Cuánta belleza",
      title2: "ves en ti?",
      body1: "6 preguntas para descubrir cómo percibes tu belleza hoy, qué áreas podrían realzarla aún más y recibir un",
      bodyStrong1: "pre-diagnóstico personalizado",
      body2: ". Al terminar te llevas un",
      bodyStrong2: "15% de descuento",
      body3: "en tu primera aplicación.",
      cta: "Descubrir mi belleza",
    },
    about: {
      eyebrow: "— Sobre Tania",
      title: "Más de una década ayudando a personas como tú a sonreír con seguridad.",
      body: "Soy la Dra. Tania Mendoza, ortodoncista certificada con especialidad en Medicina Estética. Atiendo a niños, adolescentes y adultos en Pachuca, con un trato cercano y honesto. Te explico cada paso, te doy varias opciones y armamos juntos un plan que se ajuste a tus tiempos y a tu bolsillo.",
      pillars: [
        { title: "Certificación", text: "Posgrado en Ortodoncia y diplomados en Medicina Estética." },
        { title: "Planes a tu medida", text: "Mensualidades, descuentos y MSI con tarjetas participantes." },
        { title: "Tecnología actual", text: "Diagnóstico 3D, materiales de calidad y técnicas modernas." },
        { title: "Trato humano", text: "Acompañamiento cercano antes, durante y después." },
      ],
    },
    gallery: {
      eyebrow: "— Casos reales",
      title1: "Antes & Después.",
      title2: "Resultados que",
      titleEm: "hablan por sí solos.",
      sub: "Una selección de tratamientos reales de pacientes de la Dra. Tania, publicados con su autorización.",
      before: "Antes",
      after: "Después",
      cats: { ortodoncia: "Ortodoncia", estetica: "Medicina Estética" },
    },
    testimonials: {
      eyebrow: "— Pacientes",
      title: "La voz de quienes ya confiaron en nosotros.",
      list: [
        { name: "Mariana R.", text: "Mi sonrisa cambió por completo. La Dra. Tania te explica todo con paciencia y te hace sentir tranquila." },
        { name: "Andrea V.", text: "Buen precio, resultados naturales y un trato excelente. Recomendadísima." },
        { name: "Luis F.", text: "Pude pagar mi tratamiento a meses sin intereses. Súper recomendado en Pachuca." },
        { name: "Karla M.", text: "Llevé a mi hija desde los 9 años y el cambio ha sido increíble." },
        { name: "Paola G.", text: "Mi limpieza facial me dejó la piel preciosa, regreso cada mes." },
      ],
    },
    location: {
      eyebrow: "— Ubicación",
      title1: "Visítanos en",
      title2: "Pachuca, Hidalgo",
      body: "Consultorio céntrico, fácil de llegar y con estacionamiento. Atendemos con cita previa para darte tiempo exclusivo y privacidad.",
      address: {
        title: "Dirección",
        line1: "El Pípila 200-A-5, Col. Centro",
        line2: "Pachuca de Soto, Hgo. · CP 42000",
      },
      phone: { title: "Teléfono / WhatsApp" },
      hours: {
        title: "Horario",
        weekday: "Lunes a viernes · 10:00 – 19:00",
        saturday: "Sábados · 10:00 – 14:00",
      },
      cta: "Cómo llegar",
    },
    booking: {
      eyebrow: "— Agenda",
      title: "Tu primera valoración es gratis.",
      body: "Déjanos tus datos y te contactamos por WhatsApp para confirmar tu cita. Sin compromiso, te explicamos opciones, tiempos y mensualidades.",
      payments: "Aceptamos efectivo, transferencia y tarjetas con MSI",
      fields: {
        name: "Nombre completo *",
        phone: "Teléfono *",
        email: "Correo electrónico",
        service: "Servicio *",
        date: "Fecha preferida *",
        time: "Hora preferida *",
        notes: "Notas (opcional)",
      },
      services: ["Ortodoncia", "Invisalign", "Medicina Estética", "Botox", "Ácido Hialurónico", "Limpieza Facial"],
      submit: "Solicitar cita",
      submitting: "Enviando...",
      whatsapp: "Contactar por WhatsApp",
      whatsappMsg: "Hola Dra. Tania, vengo del sitio web y quiero agendar una cita.",
      successMsg: "Cita solicitada. Te contactaremos pronto.",
      missingMsg: "Completa los campos requeridos",
      errorMsg: "Error al enviar. Intenta de nuevo.",
    },
    footer: {
      tagline: "Ortodoncia · Medicina Estética",
      desc: "Consultorio en Pachuca, Hidalgo. Tratamientos para toda la familia con planes a meses sin intereses.",
      contactTitle: "Contacto",
      socialTitle: "Síguenos",
      rights: "Todos los derechos reservados.",
      adminLink: "Acceso administrativo",
    },
    quiz: {
      header: "Quiz de belleza · Medicina Estética",
      questionLabel: (i, total) => `Pregunta ${i} de ${total}`,
      resultTitle: "Tu lectura de belleza personalizada",
      back: "Atrás",
      next: "Siguiente",
      finish: "Ver mi resultado",
      restart: "Volver a empezar",
      couponNote: "Cupón válido en tu primera valoración",
      empathyLabel: "— Lectura empática",
      preDxLabel: "Tu pre-diagnóstico",
      preDxIntro: "Según tus respuestas, podrías beneficiarte de estos tratamientos:",
      preDxDisclaimer: "El pre-diagnóstico es orientativo. El plan definitivo se confirma en la valoración presencial.",
      onlyAdvice: { pre: "Te sugerimos una ", strong: "valoración personalizada", post: " con la Dra. Tania para revisar tu rostro con calma y diseñar un plan a tu medida." },
      rewardLabel: "Tu recompensa",
      discount: "15% de descuento",
      discountBody: "en tu primera aplicación de Medicina Estética.",
      code: "CÓDIGO: BELLEZA15",
      whatsappBtn: "Agendar ahora por WhatsApp",
      whatsappMsg: ({ treatments, areas }) =>
        `Hola Dra. Tania, hice el Quiz de Belleza del sitio web. Mi pre-diagnóstico sugiere: ${treatments || "asesoría personalizada"}. Áreas de interés: ${areas || "valoración general"}. Quiero agendar mi valoración con el 15% de descuento (código BELLEZA15).`,
      tones: {
        low: { title: "Te ves preciosa, y queremos que sigas brillando", body: "Tu percepción de belleza está en un buen lugar. Pequeños retoques estéticos en este punto son una inversión en mantener ese brillo: prevenir, hidratar y resaltar lo que ya te encanta." },
        mid: { title: "Hay belleza en ti que aún no estás viendo", body: "Es totalmente normal: pequeños detalles en el rostro pueden hacer que no nos sintamos del todo cómodos al vernos. La buena noticia es que con tratamientos sutiles y naturales, esa belleza que ya tienes se puede realzar en minutos." },
        high: { title: "Tu belleza merece que la mires distinto", body: "Lo que sientes frente al espejo está afectando partes importantes de tu vida: tus fotos, tus relaciones, incluso cómo te muestras al mundo. No se trata de cambiar quién eres: se trata de devolverte la confianza para que vuelvas a verte hermosa y reconocerte." },
      },
      questions: [
        { id: "evitar", title: "¿Con qué frecuencia evitas verte al espejo, tomarte fotos o sonreír amplio porque algo de tu rostro no te gusta?", type: "single", options: [
          { v: 0, label: "Nunca, me veo bien" },
          { v: 1, label: "Una o dos veces a la semana" },
          { v: 2, label: "Varias veces por semana" },
          { v: 3, label: "Casi todos los días" },
        ]},
        { id: "emocion", title: "Cuando piensas en cómo te ves hoy, ¿qué emoción aparece primero?", type: "single", options: [
          { v: 0, label: "Me siento hermosa/o" },
          { v: 1, label: "Indiferencia, ni bien ni mal" },
          { v: 2, label: "Algo de inseguridad" },
          { v: 3, label: "No me siento atractiva/o" },
        ]},
        { id: "impacto", title: "¿Sientes que cómo percibes tu belleza influye en tu vida (relaciones, trabajo, salir, hablar en público)?", type: "single", options: [
          { v: 0, label: "Nada" },
          { v: 1, label: "Un poco" },
          { v: 2, label: "Bastante" },
          { v: 3, label: "Muchísimo, me ha frenado" },
        ]},
        { id: "areas", title: "¿Qué áreas te gustaría realzar o cuidar? (puedes elegir varias)", type: "multi", options: [
          { v: "frente", label: "Líneas en la frente / entrecejo" },
          { v: "ojos", label: "Patas de gallo (alrededor de los ojos)" },
          { v: "ojeras", label: "Ojeras o mirada cansada" },
          { v: "pomulos", label: "Pómulos o mejillas" },
          { v: "nasogeniano", label: "Líneas de la nariz a la boca" },
          { v: "labios", label: "Labios (volumen o hidratación)" },
          { v: "menton", label: "Mentón o papada" },
          { v: "piel", label: "Calidad de piel (textura, manchas)" },
          { v: "asesoria", label: "Aún no lo sé, quiero asesoría" },
        ]},
        { id: "resultado", title: "¿Qué resultado buscas?", type: "single", options: [
          { v: "descanso", label: "Verme descansada/o y fresca/o" },
          { v: "suave", label: "Suavizar líneas sin parecer 'operada/o'" },
          { v: "realzar", label: "Realzar mi belleza de forma natural" },
          { v: "asesoria", label: "Sólo quiero asesoría profesional" },
        ]},
        { id: "freno", title: "¿Qué te ha frenado de hacerlo antes?", type: "single", options: [
          { v: "miedo", label: "Miedo a que se note demasiado" },
          { v: "precio", label: "El precio" },
          { v: "empezar", label: "No saber por dónde empezar" },
          { v: "listo", label: "Nada, ya estoy lista/o" },
        ]},
      ],
      treatments: {
        frente: "Toxina botulínica",
        ojos: "Toxina botulínica",
        ojeras: "Ácido hialurónico (ojeras)",
        pomulos: "Ácido hialurónico (volumen en pómulos)",
        nasogeniano: "Ácido hialurónico (relleno nasogeniano)",
        labios: "Ácido hialurónico labial",
        menton: "Toxina + ácido hialurónico",
        piel: "Limpieza facial + peeling",
      },
    },
  },
  en: {
    nav: { services: "Services", quiz: "Self-Esteem Quiz", about: "About Tania", cases: "Cases", patients: "Patients", location: "Location", contact: "Contact", admin: "Admin", book: "Book appointment" },
    hero: {
      badge: "Pachuca, Hidalgo · Mexico",
      titlePre: "Smile with",
      titleHighlight: "confidence",
      titlePost: ", live with security.",
      subtitlePre: "",
      subtitleStrong1: "Orthodontics",
      subtitleAnd: "and",
      subtitleStrong2: "Aesthetic Medicine",
      subtitleBody: "with Dr. Tania Mendoza in Pachuca. Caring service, treatments for every age and",
      subtitleStrong3: "monthly plans with no interest",
      subtitleEnd: ". Your first consultation is free.",
      cta: "Free consultation",
      linkServices: "See our services",
      stat1: { n: (p) => `+${p}`, label: "Patients" },
      stat2: { n: (y) => `${y} years`, label: "Experience" },
      stat3: { n: "0% APR", label: "Monthly plans" },
      stat4: { n: "Free", label: "1st consultation" },
      certBadge: "Certified",
      university: "Autonomous University of Hidalgo State",
    },
    services: {
      eyebrow: "— Services",
      title1: "Two specialties.",
      title2: "One goal:",
      titleEm: "for you to feel great about yourself.",
      sub: "Treatments for kids, teens and adults. We design a plan that fits your goals and budget.",
      tabs: { estetica: "Aesthetic Medicine", ortodoncia: "Orthodontics" },
      list: [
        // Aesthetic Medicine
        { id: "toxina", title: "Botulinum Toxin", area: "estetica", desc: "Softens dynamic lines on forehead, glabella and crow's feet. Natural finish, never frozen." },
        { id: "ellanse", title: "Ellansé", area: "estetica", desc: "Premium collagen biostimulator for deep rejuvenation. Results lasting up to 4 years." },
        { id: "rino", title: "Non-Surgical Rhinoplasty", area: "estetica", desc: "Reshape the nose profile with hyaluronic acid. No scalpel, no downtime." },
        { id: "labios", title: "Lip Filler", area: "estetica", desc: "Volume and definition with premium hyaluronic acid. Harmonious, hydrated, natural look." },
        { id: "ojeras", title: "Tear Trough Filler", area: "estetica", desc: "Rejuvenate the under-eye area with HA and biostimulators. A rested, refreshed look." },
        { id: "marcaje", title: "Jawline & Chin Sculpting", area: "estetica", desc: "Define facial oval with hyaluronic acid. Sharp jawline and harmonious chin." },
        { id: "pomulos", title: "Cheeks & Full Face", area: "estetica", desc: "Restore facial support with an integral technique. Natural lift, no surgery." },
        { id: "pdrn", title: "Salmon PDRN & Exosomes", area: "estetica", desc: "Cutting-edge cellular regeneration. Improves texture, firmness and glow." },
        { id: "enzimas", title: "Lipolytic Enzymes", area: "estetica", desc: "Reduce double-chin and localized fat. Visible results in a few sessions." },
        // Orthodontics
        { id: "brackets", title: "Braces", area: "ortodoncia", desc: "Metal, ceramic or sapphire. For kids, teens and adults, with interest-free monthly plans." },
        { id: "invisalign", title: "Clear Aligners", area: "ortodoncia", desc: "Invisalign and affordable alternatives. Comfortable, clear and almost invisible." },
        { id: "ortopedia", title: "Maxillary Orthopedics", area: "ortodoncia", desc: "Early treatment for kids: prevents bigger issues and saves future costs." },
      ],
    },
    credentials: {
      eyebrow: "— Training",
      title1: "Continuous training",
      title2: "at top institutions.",
      sub: "Dr. Tania constantly updates her practice to offer safe, cutting-edge techniques.",
      list: [
        { school: "Autonomous University of Hidalgo State", title: "Dentistry", year: "" },
        { school: "AOMEI — Mexican Dental Association", title: "Orthodontics Specialty", year: "" },
      ],
    },
    quizCta: {
      tag: "Quiz · 2 minutes",
      title1: "How much beauty",
      title2: "do you see in yourself?",
      body1: "6 questions to discover how you perceive your beauty today, which areas could enhance it even more and receive a",
      bodyStrong1: "personalized pre-diagnosis",
      body2: ". When you finish you get a",
      bodyStrong2: "15% discount",
      body3: "on your first treatment.",
      cta: "Discover my beauty",
    },
    about: {
      eyebrow: "— About Tania",
      title: "Over a decade helping people like you smile with confidence.",
      body: "I'm Dr. Tania Mendoza, certified orthodontist with a specialty in Aesthetic Medicine. I see kids, teens and adults in Pachuca with a warm and honest approach. I explain every step, give you several options, and build a plan together that fits your time and budget.",
      pillars: [
        { title: "Certification", text: "Postgraduate in Orthodontics and diplomas in Aesthetic Medicine." },
        { title: "Tailored plans", text: "Installments, discounts and 0% APR with participating cards." },
        { title: "Modern technology", text: "3D diagnostics, quality materials and modern techniques." },
        { title: "Human care", text: "Close support before, during and after." },
      ],
    },
    gallery: {
      eyebrow: "— Real cases",
      title1: "Before & After.",
      title2: "Results that",
      titleEm: "speak for themselves.",
      sub: "A selection of real treatments by Dr. Tania, shared with patient consent.",
      before: "Before",
      after: "After",
      cats: { ortodoncia: "Orthodontics", estetica: "Aesthetic Medicine" },
    },
    testimonials: {
      eyebrow: "— Patients",
      title: "Voices of those who already trusted us.",
      list: [
        { name: "Mariana R.", text: "My smile changed completely. Dr. Tania explains everything patiently and makes you feel calm." },
        { name: "Andrea V.", text: "Fair price, natural results and excellent service. Highly recommended." },
        { name: "Luis F.", text: "I was able to pay my treatment in monthly installments with 0% APR. Super recommended in Pachuca." },
        { name: "Karla M.", text: "I brought my daughter when she was 9 and the change has been incredible." },
        { name: "Paola G.", text: "My facial left my skin gorgeous, I come back every month." },
      ],
    },
    location: {
      eyebrow: "— Location",
      title1: "Visit us in",
      title2: "Pachuca, Hidalgo",
      body: "Centrally located practice, easy to reach, with parking. By appointment only so you get exclusive time and privacy.",
      address: {
        title: "Address",
        line1: "El Pípila 200-A-5, Col. Centro",
        line2: "Pachuca de Soto, Hgo. · ZIP 42000",
      },
      phone: { title: "Phone / WhatsApp" },
      hours: {
        title: "Hours",
        weekday: "Monday – Friday · 10:00 AM – 7:00 PM",
        saturday: "Saturday · 10:00 AM – 2:00 PM",
      },
      cta: "Get directions",
    },
    booking: {
      eyebrow: "— Book",
      title: "Your first consultation is free.",
      body: "Leave us your info and we'll reach out via WhatsApp to confirm. No commitment — we'll explain options, timing and monthly plans.",
      payments: "We accept cash, transfer and credit cards with 0% APR",
      fields: {
        name: "Full name *",
        phone: "Phone *",
        email: "Email",
        service: "Service *",
        date: "Preferred date *",
        time: "Preferred time *",
        notes: "Notes (optional)",
      },
      services: ["Orthodontics", "Invisalign", "Aesthetic Medicine", "Botox", "Hyaluronic Acid", "Facial Cleansing"],
      submit: "Request appointment",
      submitting: "Sending...",
      successMsg: "Appointment requested. We'll contact you soon.",
      missingMsg: "Please complete the required fields",
      errorMsg: "Error sending. Please try again.",
    },
    footer: {
      tagline: "Orthodontics · Aesthetic Medicine",
      desc: "Clinic in Pachuca, Hidalgo. Treatments for the whole family with interest-free monthly plans.",
      contactTitle: "Contact",
      socialTitle: "Follow us",
      rights: "All rights reserved.",
      adminLink: "Admin access",
    },
    quiz: {
      header: "Beauty quiz · Aesthetic Medicine",
      questionLabel: (i, total) => `Question ${i} of ${total}`,
      resultTitle: "Your personalized beauty reading",
      back: "Back",
      next: "Next",
      finish: "See my result",
      restart: "Start over",
      couponNote: "Coupon valid on your first consultation",
      empathyLabel: "— Empathic reading",
      preDxLabel: "Your pre-diagnosis",
      preDxIntro: "Based on your answers, you could benefit from these treatments:",
      preDxDisclaimer: "The pre-diagnosis is informative. The final plan is confirmed in your in-person consultation.",
      onlyAdvice: { pre: "We suggest a ", strong: "personalized consultation", post: " with Dr. Tania to review your face carefully and design a tailored plan." },
      rewardLabel: "Your reward",
      discount: "15% discount",
      discountBody: "on your first Aesthetic Medicine treatment.",
      code: "CODE: BELLEZA15",
      whatsappBtn: "Book now via WhatsApp",
      whatsappMsg: ({ treatments, areas }) =>
        `Hi Dr. Tania, I took the Beauty Quiz on your website. My pre-diagnosis suggests: ${treatments || "personalized consultation"}. Areas of interest: ${areas || "general consultation"}. I'd like to book my consultation with the 15% discount (code BELLEZA15).`,
      tones: {
        low: { title: "You look stunning, and we want you to keep shining", body: "Your beauty perception is in a great place. Small aesthetic touches at this stage are an investment in keeping that glow: prevent, hydrate and enhance what you already love." },
        mid: { title: "There's beauty in you that you're not seeing yet", body: "It's perfectly normal: small details on the face can make us not feel fully comfortable when we look at ourselves. The good news: with subtle and natural treatments, that beauty you already have can be enhanced in minutes." },
        high: { title: "Your beauty deserves a new look", body: "What you feel in front of the mirror is affecting important parts of your life: your photos, your relationships, even how you show up. It's not about changing who you are: it's about returning your confidence so you can see yourself beautiful again." },
      },
      questions: [
        { id: "evitar", title: "How often do you avoid looking in the mirror, taking photos, or smiling widely because of something on your face you don't like?", type: "single", options: [
          { v: 0, label: "Never, I look good" },
          { v: 1, label: "Once or twice a week" },
          { v: 2, label: "Several times a week" },
          { v: 3, label: "Almost every day" },
        ]},
        { id: "emocion", title: "When you think about how you look today, which emotion comes up first?", type: "single", options: [
          { v: 0, label: "I feel beautiful" },
          { v: 1, label: "Indifference, neutral" },
          { v: 2, label: "Some insecurity" },
          { v: 3, label: "I don't feel attractive" },
        ]},
        { id: "impacto", title: "Do you feel how you perceive your beauty has influenced your life (relationships, work, going out, public speaking)?", type: "single", options: [
          { v: 0, label: "Not at all" },
          { v: 1, label: "A little" },
          { v: 2, label: "Quite a lot" },
          { v: 3, label: "A lot, it's held me back" },
        ]},
        { id: "areas", title: "Which areas would you like to enhance or take care of? (choose any that apply)", type: "multi", options: [
          { v: "frente", label: "Forehead / between brows" },
          { v: "ojos", label: "Crow's feet (around the eyes)" },
          { v: "ojeras", label: "Under-eye circles" },
          { v: "pomulos", label: "Cheeks / cheekbones" },
          { v: "nasogeniano", label: "Nose-to-mouth lines" },
          { v: "labios", label: "Lips (volume or hydration)" },
          { v: "menton", label: "Chin / double chin" },
          { v: "piel", label: "Skin quality (texture, spots)" },
          { v: "asesoria", label: "Not sure yet, I want advice" },
        ]},
        { id: "resultado", title: "What result are you looking for?", type: "single", options: [
          { v: "descanso", label: "Look rested and fresh" },
          { v: "suave", label: "Soften lines without looking 'done'" },
          { v: "realzar", label: "Enhance my beauty naturally" },
          { v: "asesoria", label: "Just professional advice" },
        ]},
        { id: "freno", title: "What has stopped you from doing it before?", type: "single", options: [
          { v: "miedo", label: "Fear it would be too noticeable" },
          { v: "precio", label: "The price" },
          { v: "empezar", label: "Not knowing where to start" },
          { v: "listo", label: "Nothing, I'm ready" },
        ]},
      ],
      treatments: {
        frente: "Botulinum toxin",
        ojos: "Botulinum toxin",
        ojeras: "Hyaluronic acid (under-eye)",
        pomulos: "Hyaluronic acid (cheek volume)",
        nasogeniano: "Hyaluronic acid (nasolabial filler)",
        labios: "Lip hyaluronic acid",
        menton: "Toxin + hyaluronic acid",
        piel: "Facial cleansing + peel",
      },
    },
  },
};

const Ctx = createContext({ lang: "es", setLang: () => {}, t: dict.es });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "es";
    return localStorage.getItem(KEY) || "es";
  });
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = (l) => { localStorage.setItem(KEY, l); setLangState(l); };
  const value = useMemo(() => ({ lang, setLang, t: dict[lang] }), [lang]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useLang = () => useContext(Ctx);
